import { render } from "./App.vue?vue&type=template&id=1b20b406"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1b20b406&lang=sass"

import exportComponent from "/home/runner/work/wiki.zems.pro/wiki.zems.pro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__